<template>
  <!-- loader Start -->
  <div id="loading" :style="style" v-bind:class="{ 'd-none': !loading }">
    <div id="loading-center"></div>
  </div>
  <!-- loader END -->
</template>
<script>
import darkLoader from "../../../assets/images/darkMode/dark-logo.gif";
import lightLoader from "../../../assets/images/oc-logo.png";
import { mapGetters } from "vuex";
export default {
  name: "CustomLoader",
  props: {
    dark: { type: Boolean, default: false },
    loading: { type: Boolean, default: false }
  },
  // watch: {
  //   $route: function(to, from) {
  //     // eslint-disable-next-line no-mixed-operators
  //     if (
  //       (to.meta.layout !== undefined && from.meta.layout === undefined) ||
  //       (to.meta.layout === undefined && from.meta.layout !== undefined) ||
  //       (to.meta.layout !== undefined && from.meta.layout !== undefined)
  //     ) {
  //       const load = document.getElementById("loading");
  //       animation.fadeIn(load, { duration: 50 });
  //       load.classList.remove("d-none");
  //     }
  //   }
  // },
  computed: {
    style() {
      if (this.darkMode) {
        return `background: #252549 url(${darkLoader}) no-repeat scroll center center;background-size: 150px;`;
      } else {
        return `background: #fff url(${lightLoader}) no-repeat scroll center center; background-size: 5% !important;`;
      }
    },
    ...mapGetters({
      darkMode: "Setting/darkModeState"
    })
  },
  mounted() {}
};
</script>
